export default {
  address: {
    line1: "2828 boulevard Laurier, suite 700",
    line2: "Québec, QC G1V 0B9",
    country: "Canada",
  },
  seo: {
    title: "Consultants Succès Inc | Financement d'entreprise à Québec",
    description: "Financement d'entreprise à Québec depuis 2016 : fonds de roulement, cartes de crédit corporatives et financement de projets immobiliers. Consultants Succès Inc — Vladimir Blain, consultant principal.",
  },
  nav: {
    services: "Services",
    solutions: "Solutions",
    approche: "Approche",
    consultant: "Consultant",
    faq: "FAQ",
    contact: "Contact",
    vytali: "Découvrir Vytali",
    apply: "Faire une demande",
    portal: "Accéder à mon espace",
    impact: "Impact social",
    ariaMenu: "Menu",
    ariaChangeLang: "Changer de langue",
  },
  impactHome: {
    eyebrow: "Impact social",
    title: "Le succès qui crée un impact",
    text: "En complément de nos activités en financement et en accompagnement des entrepreneurs, Consultants Succès participe aussi à certaines initiatives sociales, communautaires et caritatives aux côtés de partenaires engagés.",
    cta: "Découvrir notre impact social",
  },
  impact: {
    seoTitle: "Impact social | Consultants Succès",
    seoDesc: "Découvrez l'engagement social et communautaire de Consultants Succès et les initiatives auxquelles nous participons aux côtés de partenaires engagés.",
    heroTitle: "Le succès prend tout son sens lorsqu'il contribue aussi aux autres.",
    heroSubtitle: "Consultants Succès participe à différentes initiatives sociales, communautaires et caritatives afin de contribuer positivement aux communautés dans lesquelles nous évoluons.",
    heroCta1: "Découvrir nos initiatives",
    heroCta2: "Nous joindre",
    engagementTitle: "Notre engagement",
    engagementParas: [
      "Chez Consultants Succès, nous croyons que la croissance économique et l'impact humain peuvent avancer ensemble.",
      "Notre activité principale demeure l'accompagnement des entrepreneurs, le financement d'entreprise et le financement de projets.",
      "Parallèlement, nous participons à certaines initiatives sociales, communautaires et caritatives en collaboration avec des partenaires engagés.",
      "Notre objectif est de contribuer à créer des retombées positives au-delà des affaires.",
    ],
    howTitle: "Comment nous contribuons",
    howItems: [
      { title: "Initiatives communautaires", text: "Participation à des initiatives visant à soutenir et mobiliser les communautés." },
      { title: "Campagnes caritatives", text: "Collaboration à certaines campagnes caritatives aux côtés de partenaires et d'organismes engagés." },
      { title: "Mobilisation de partenaires", text: "Création de ponts entre entreprises, partenaires et initiatives ayant un impact positif." },
      { title: "Événements et sensibilisation", text: "Participation à des événements et actions permettant de sensibiliser, mobiliser et rassembler." },
    ],
    initiativesTitle: "Nos initiatives",
    initiativesCardTitle: "Des initiatives qui évoluent avec notre engagement",
    initiativesCardText: "Consultants Succès participe et collaborera à différentes initiatives sociales et communautaires. Les campagnes et projets pouvant être communiqués publiquement seront présentés ici progressivement.",
    participateItems: [
      { title: "Participer", text: "Découvrez les initiatives et activités auxquelles Consultants Succès participe." },
      { title: "Collaborer", text: "Entreprises, partenaires et organisations peuvent communiquer avec nous pour explorer certaines possibilités de collaboration." },
      { title: "Soutenir", text: "Lorsque certaines campagnes le permettent, les modalités de participation ou de soutien seront clairement affichées." },
    ],
    transparencyTitle: "Une approche transparente",
    transparencyParas: [
      "Consultants Succès peut participer à des campagnes, événements ou initiatives en collaboration avec différents partenaires ou organismes. Lorsque des dons ou contributions financières sont associés à une initiative, les modalités applicables ainsi que l'organisme bénéficiaire doivent être clairement identifiés.",
      "Consultants Succès n'est pas un organisme de bienfaisance enregistré.",
    ],
  },
  hero: {
    kicker: "Financement d'entreprise — Québec, depuis 2016",
    lines: ["Le capital qu'il faut,", "au moment où", "ça compte."],
    subtitle: "Fonds de roulement, crédit corporatif et projets immobiliers. Consultants Succès Inc accompagne les entrepreneurs québécois vers le financement qui fait avancer leurs projets.",
    primaryCta: "Planifier ma stratégie de financement",
    vytaliCta: "Découvrir Vytali",
  },
  trust: {
    tagline: "Plus de solutions. Plus de possibilités.",
    taglineGold: "Plus de croissance.",
    items: [
      { title: "Réseau de prêteurs spécialisés", desc: "Accédez à plusieurs solutions de financement adaptées à votre entreprise." },
      { title: "Analyse rapide des dossiers", desc: "Nous analysons votre demande afin d'identifier les meilleures options disponibles." },
      { title: "Accompagnement personnalisé", desc: "Un conseiller vous accompagne à chaque étape jusqu'à l'obtention de votre financement." },
    ],
  },
  stats: {
    heading: "Une décennie de résultats",
    headingGold: "mesurables",
    sub: "« Rookie de l'année » en 2017, un an après notre fondation. La suite n'a jamais ralenti.",
    labels: ["Fondation en mars", "Managers promus", "Prix remportés au Gala", "Employés formés"],
  },
  marquee: {
    items: ["CONSULTANTS SUCCÈS INC", "FINANCEMENT", "STRATÉGIE", "RÉSULTATS", "QUÉBEC", "DEPUIS 2016"],
  },
  services: {
    kicker: "Nos services",
    heading: "Trois leviers pour financer votre ambition",
    discuss: "En discuter",
    items: [
      { title: "Financement d'entreprise", desc: "Obtenez le fonds de roulement nécessaire pour stabiliser vos opérations, saisir des opportunités et soutenir votre croissance sans compromettre votre liquidité." },
      { title: "Cartes de crédit", desc: "Une ligne de crédit établie au nom de votre entreprise — pas au vôtre. Bâtissez votre crédit corporatif et séparez vos finances personnelles de celles de votre compagnie." },
      { title: "Projets immobiliers", desc: "Financement structuré pour l'acquisition d'immeubles et la réalisation de projets multiples. De la première propriété au portefeuille complet." },
    ],
  },
  solutions: {
    kicker: "Nos solutions de financement",
    heading: "Une offre complète, adaptée à",
    headingGold: "votre réalité",
    request: "Faire une demande",
    items: [
      { title: "Fonds de roulement", desc: "Du capital rapide pour soutenir vos opérations quotidiennes et saisir les occasions sans attendre." },
      { title: "Financement d'équipement", desc: "Acquérez la machinerie et les équipements nécessaires à votre croissance sans immobiliser vos liquidités." },
      { title: "Financement de factures", desc: "Transformez vos comptes clients en liquidités immédiates plutôt que d'attendre 30, 60 ou 90 jours." },
      { title: "Immobilier commercial", desc: "Financement structuré pour l'acquisition, la conversion ou le développement de propriétés commerciales." },
      { title: "Crédit corporatif", desc: "Bâtissez le crédit de votre entreprise avec des cartes et lignes de crédit à son nom, pas au vôtre." },
      { title: "Croissance et expansion", desc: "Du capital structuré pour ouvrir un nouvel emplacement, embaucher ou conquérir de nouveaux marchés." },
    ],
  },
  etapes: {
    kicker: "Notre approche",
    heading: "Quatre étapes.",
    headingGold: "Une méthode éprouvée.",
    steps: [
      { title: "Étude du marché", desc: "Nous analysons votre secteur, vos concurrents et votre positionnement pour identifier les occasions de financement les plus avantageuses." },
      { title: "Informer la clientèle", desc: "Une communication claire et transparente : vous comprenez chaque option, chaque condition, avant de prendre une décision." },
      { title: "Vendre", desc: "Nous présentons votre dossier sous son meilleur jour aux bonnes institutions, pour maximiser vos chances d'approbation." },
      { title: "Fidéliser", desc: "La relation ne s'arrête pas à l'approbation. Nous restons à vos côtés pour vos prochains projets et votre croissance à long terme." },
    ],
  },
  consultant: {
    kicker: "Consultant principal",
    role: "Consultant principal",
    heading: "Vladimir Blain, l'allié des entrepreneurs qui voient grand",
    p1: "À la tête de Consultants Succès depuis mars 2016, Vladimir Blain a bâti une équipe reconnue — « Rookie de l'année » dès 2017, six prix au Gala, cinq managers promus et plus de trente employés formés. Sa conviction : chaque entreprise mérite un accès clair et rapide au capital qui la fera grandir.",
    p2Before: "Aujourd'hui, il connecte le financement à la croissance en dirigeant aussi ",
    p2Brand: "Vytali Marketing",
    p2After: " — la plateforme qui aide les entreprises québécoises à générer et convertir plus de clients.",
    promoBefore: "Propulsé par ",
    promoBrand: "Vytali",
    promoAfter: ", notre plateforme d'intelligence commerciale, pour des analyses plus rapides et des réponses plus précises à vos demandes de financement.",
    vytaliCta: "Découvrir Vytali",
    writeCta: "Écrire à l'équipe",
    photoAlt: "Vladimir Blain, consultant principal",
  },
  calc: {
    eyebrow: "Outil de simulation",
    title: "Estimez vos paiements.",
    desc: "Simulez différents scénarios de financement à titre indicatif.",
    amountLabel: "Montant du financement",
    termLabel: "Durée",
    termUnit: "mois",
    rateLabel: "Taux annuel estimatif",
    rateHelp: "Utilisez un taux estimatif pour explorer différents scénarios. Le taux réel dépendra du produit, du prêteur, de l'admissibilité et des modalités applicables.",
    illustrative: "Scénario illustratif — ajustez les valeurs selon votre situation.",
    resultTitle: "Paiement mensuel estimatif",
    perMonth: "/ mois",
    sumAmount: "Montant simulé",
    sumTerm: "Durée",
    sumRate: "Taux estimatif",
    disclaimer: "Cette simulation est fournie à titre informatif uniquement. Elle ne constitue ni une offre de financement ni une approbation. Les taux, paiements et conditions réels peuvent varier selon le produit, le prêteur, l'admissibilité et les modalités applicables.",
    cta: "Obtenir une offre personnalisée",
    contactMessage: "Je souhaite discuter du scénario de financement que je viens de simuler.",
    errAmount: "Entrez un montant supérieur à 0.",
    errTerm: "Entrez une durée en mois entre 1 et 600.",
    errRate: "Entrez un taux entre 0 et 100.",
  },
  faq: {
    kicker: "FAQ",
    heading: "Vos questions sur le",
    headingGold: "financement",
    sub: "Fonds de roulement, crédit corporatif, immobilier — les réponses aux questions qu'on nous pose le plus souvent.",
    items: [
      { q: "Qu'est-ce qu'un fonds de roulement et à quoi sert-il ?", a: "Le fonds de roulement est le capital dont votre entreprise dispose pour couvrir ses opérations courantes : inventaire, salaires, fournisseurs, marketing. Un financement de fonds de roulement vous permet de saisir des opportunités et de traverser les périodes creuses sans compromettre votre liquidité." },
      { q: "Quelle est la différence entre une carte de crédit personnelle et une carte corporative ?", a: "Une carte corporative est établie au nom de votre entreprise, pas au vôtre. Elle bâtit l'historique de crédit de votre compagnie, sépare vos finances personnelles de celles de l'entreprise et protège votre cote de crédit personnelle. C'est une étape essentielle pour accéder à du financement plus important par la suite." },
      { q: "Mon entreprise est jeune — puis-je quand même obtenir du financement ?", a: "Oui. Notre rôle est justement de structurer votre dossier pour le présenter sous son meilleur jour aux bonnes institutions. Chaque situation est unique : écrivez-nous et nous évaluerons ensemble les options adaptées à votre stade de croissance." },
      { q: "Financez-vous les projets immobiliers ?", a: "Absolument. Nous accompagnons l'acquisition d'immeubles et la réalisation de projets multiples — de la première propriété au portefeuille complet. Nous structurons le financement selon la nature du projet : acquisition, conversion ou développement." },
      { q: "Combien de temps prend le processus ?", a: "Cela dépend du type de financement et de la préparation de votre dossier. Notre méthode en 4 étapes (étude, information, présentation, suivi) vise à accélérer chaque phase. Contactez-nous pour une évaluation initiale rapide de votre situation." },
      { q: "Vos services sont-ils réservés à la région de Québec ?", a: "Notre bureau est situé à Québec (2828 boulevard Laurier, suite 700), mais nous accompagnons des entrepreneurs partout au Québec. La majorité des démarches peuvent se faire à distance : +1 581-333-3447." },
    ],
  },
  contact: {
    kicker: "Contact",
    heading: "Parlons de votre projet",
    sub: "Une question sur le financement, les cartes de crédit corporatives ou un projet immobilier ? Écrivez-nous — un membre de l'équipe vous répond rapidement.",
    nameLabel: "Nom complet",
    namePh: "Votre nom",
    phoneLabel: "Téléphone",
    phonePh: "Ex. : 514-555-1234",
    emailLabel: "Courriel",
    emailPh: "vous@entreprise.com",
    solutionLabel: "Solution recherchée",
    solutionOptional: "(optionnel)",
    solutionPh: "Ex. : Fonds de roulement, Immobilier commercial…",
    solutionSelectPh: "Sélectionnez une solution…",
    messageLabel: "Votre question",
    messagePh: "Décrivez votre projet ou posez votre question…",
    submit: "Envoyer ma question",
    sending: "Envoi en cours…",
    fillAll: "Veuillez remplir tous les champs.",
    errName: "Veuillez entrer votre nom complet.",
    errEmail: "Veuillez entrer une adresse courriel valide.",
    errPhone: "Veuillez entrer un numéro de téléphone valide.",
    success: "Message envoyé ! Nous vous répondrons rapidement.",
    error: "Une erreur est survenue. Veuillez réessayer.",
    rateLimited: "Trop de messages envoyés. Veuillez réessayer dans quelques minutes.",
    mapTitle: "Bureau de Consultants Succès — 2828 boulevard Laurier, Québec",
    mapLink: "Itinéraire sur Google Maps",
    consentNote: "En soumettant ce formulaire, vous demandez à être contacté par Consultants Succès Inc au sujet de votre demande. Vos coordonnées ne sont utilisées que pour ce suivi.",
  },
  footer: {
    desc: "Le partenaire financier des entreprises québécoises : financement d'entreprise, crédit corporatif et projets immobiliers. Fondée en mars 2016.",
    coordinates: "Coordonnées",
    follow: "Suivez-nous",
    vytali: "Découvrir Vytali",
    rights: "Tous droits réservés.",
    role: "Vladimir Blain — Consultant principal",
  },
  call: {
    main: "Bureau principal",
    quebec: "Bureau de Québec",
    ariaOpen: "Appeler Consultants Succès",
    ariaClose: "Fermer le menu d'appel",
  },
};
